<template>
  <GeneralTheme :theme="configuration">
    <WistiaVideo
      v-if="wistiaVideo"
      v-bind="wistiaVideo"
    />
  </GeneralTheme>
</template>

<script lang="ts" setup>
import WistiaVideo from '~/components/Atoms/WistiaVideo/WistiaVideo.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import type { SectionBuilderWistiaVideo } from '~/sanity/types';
defineProps<SectionBuilderWistiaVideo>();
</script>

<style></style>
